<div [class.container]="isVerticalLayout$ | async" class="toolbar w-full px-gutter flex items-center shadow-b">
  @if (aplicationType !== aplicationTypeName.adminUsers) {
    <button (click)="openSidenav()" [class.hidden]="!mobileQuery" mat-icon-button type="button">
      <mat-icon svgIcon="mat:menu"></mat-icon>
    </button>

    <nx-ratenow-ui-breadcrumbs></nx-ratenow-ui-breadcrumbs>

    @if (isVerticalLayout$ | async) {
      <a [routerLink]="['/']" class="ltr:mr-4 rtl:ml-4 flex items-center">
        <img alt="Logo" class="w-8 select-none" src="assets/img/demo/logo.svg" />
        <h1 [class.hidden]="!mobileQuery" class="title ltr:pl-4 rtl:pr-4 m-0 select-none">RateNow</h1>
      </a>
    }
  } @else {
    <div class="flex gap-3">
      <a [routerLink]="['/']" class="is-navigable flex items-center">
        <mat-icon svgIcon="mat:home" class="icon-sm"></mat-icon>
      </a>

      <button class="ratenow-sidenav-item gap-2" color="primary" matButton="filled" type="button" [routerLink]="['/documentation/guides']">
        <mat-icon [svgIcon]="'mat:book'" class="ratenow-sidenav-item__icon"></mat-icon>
        <span> Guias </span>
      </button>
    </div>
  }

  <!-- TODO: Add this button when we have miore options to add not only benchmark -->
  <!-- <button
  *ngIf="isHorizontalLayout$ | async"
  [class.hidden]="mobileQuery"
  [matMenuTriggerFor]="addNewMenu"
  color="primary"
  mat-flat-button
  type="button"
  >
  Add New
</button>

<mat-menu
  #addNewMenu="matMenu"
  [overlapTrigger]="false"
  xPosition="after"
  yPosition="below"
  >
  <button [matMenuTriggerFor]="addClientMenu" mat-menu-item>
    <mat-icon svgIcon="mat:person_add"></mat-icon>
    <span>Add Client</span>
  </button>

  <button mat-menu-item>
    <mat-icon svgIcon="mat:insights"></mat-icon>
    <span>Add Benchmark</span>
  </button>
</mat-menu>

<mat-menu #addClientMenu="matMenu">
  <button mat-menu-item>
    <mat-icon svgIcon="mat:dvr"></mat-icon>
    <span>Add Device</span>
  </button>

  <button mat-menu-item>
    <mat-icon svgIcon="mat:assignment"></mat-icon>
    <span>Add Survey</span>
  </button>

  <button mat-menu-item>
    <mat-icon svgIcon="mat:receipt"></mat-icon>
    <span>Add Report</span>
  </button>
</mat-menu> -->

  <span class="flex-1"></span>

  <div class="flex items-center h-full">
    <!-- TODO: ADD search -->
    <!-- <div class="px-1">
  <button (click)="openSearch()" mat-icon-button type="button">
    <mat-icon color="primary" svgIcon="mat:search"></mat-icon>
  </button>
</div> -->

    <!-- TODO: ADD Notifications when we have time -->
    @if (aplicationType === aplicationTypeName.closeTheLoop) {
      <div class="px-1">
        <nx-ratenow-toolbar-notifications></nx-ratenow-toolbar-notifications>
      </div>
    }

    <!-- TODO: ADD Quickpanel when we have time -->
    <!-- <div class="px-1">
<button (click)="openQuickpanel()" mat-icon-button type="button">
  <mat-icon color="primary" svgIcon="mat:bookmarks"></mat-icon>
</button>
</div> -->

    @if (aplicationType === aplicationTypeName.adminWeb) {
      <div class="px-1">
        <button (click)="setDarkMode()" mat-icon-button type="button">
          @if (!getDarkMode()) {
            <mat-icon color="primary" class="primary-icon" svgIcon="mat:dark_mode"></mat-icon>
          }
          @if (getDarkMode()) {
            <mat-icon color="primary" class="primary-icon" svgIcon="mat:light_mode"></mat-icon>
          }
        </button>
      </div>
    }

    <div class="px-1">
      <button [matMenuTriggerFor]="languageMenu" mat-icon-button type="button">
        <!-- <mat-icon [svgIcon]="'flag:' + selectedLanguage.flag"></mat-icon> -->
        {{ selectedLanguage }}
      </button>
    </div>

    <div #megaMenuOriginRef>
      @if (isHorizontalLayout$ | async) {
        <button
          [class.hidden]="mobileQuery"
          (click)="openMegaMenu(megaMenuOriginRef)"
          [ngClass]="{ 'bg-primary/10': megaMenuOpen$ | async }"
          color="primary"
          mat-icon-button
          type="button"
        >
          <mat-icon svgIcon="mat:apps"></mat-icon>
        </button>
      }
    </div>

    @if (userVisible$ | async) {
      <div class="px-1">
        <nx-ratenow-toolbar-user></nx-ratenow-toolbar-user>
      </div>
    }

    <mat-menu #languageMenu="matMenu" overlapTrigger="false" xPosition="before" yPosition="below">
      @for (language of languages; track language) {
        <button mat-menu-item (click)="switchLanguage(language)">
          <!-- <mat-icon [svgIcon]="'flag:' + language.flag"></mat-icon> -->
          <span>{{ language | translateEnum: enumsByType.LANGUAGES }} </span>
        </button>
      }
    </mat-menu>
  </div>
</div>
